import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setBreadcrumbs } from '../reducers/app';

export default function useBreadcrumbs(createBreadcrumbs, dependencies) {
  const dispatch = useDispatch();
  const create = useCallback(() => {
    return createBreadcrumbs(...dependencies);
  }, [createBreadcrumbs, dependencies]);

  useEffect(() => {
    const breadcrumbs = create();
    if (breadcrumbs) {
      dispatch(setBreadcrumbs(breadcrumbs));
      const last = breadcrumbs[breadcrumbs.length - 1];
      if (document) document.title = `${last.title} | Pivot Analysis`;
    }
  }, [create, dispatch]);
}
